import * as React from 'react';
import {
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Button,
} from '@material-ui/core';

import { useStyles } from './styles';

interface SubmitSummaryProps {
  result: IBulkQuoteCreateResponse;
  rows: IBulkQuoteRow[];
  onGoResults: () => void;
  onNewBatch: () => void;
}

const plateOf = (rows: IBulkQuoteRow[], index: number) =>
  rows[index] ? rows[index].licenseVehicle || `fila ${index + 1}` : `fila ${index + 1}`;

const SubmitSummary: React.FC<SubmitSummaryProps> = ({ result, rows, onGoResults, onNewBatch }) => {
  const classes = useStyles();
  const { counts, accepted, rejected } = result;

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Lote creado
      </Typography>

      <div className={classes.chips}>
        <Chip label={`Recibidas: ${counts.received}`} />
        <Chip label={`Aceptadas: ${counts.accepted}`} className={classes.ok} />
        <Chip
          label={`Rechazadas: ${counts.rejected}`}
          className={counts.rejected ? classes.bad : undefined}
        />
      </div>

      {rejected.length > 0 && (
        <>
          <Typography className={classes.section}>Filas rechazadas</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Fila</TableCell>
                <TableCell>Placa</TableCell>
                <TableCell>Motivo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rejected.map((r) => (
                <TableRow key={r.index}>
                  <TableCell>{r.index + 1}</TableCell>
                  <TableCell>{plateOf(rows, r.index)}</TableCell>
                  <TableCell>{r.reason}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}

      {accepted.length > 0 && (
        <>
          <Typography className={classes.section}>Cotizaciones creadas</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Fila</TableCell>
                <TableCell>Placa</TableCell>
                <TableCell>uuid</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {accepted.map((a) => (
                <TableRow key={a.uuid}>
                  <TableCell>{a.index + 1}</TableCell>
                  <TableCell>{plateOf(rows, a.index)}</TableCell>
                  <TableCell className={classes.mono}>{a.uuid}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}

      <div className={classes.actions}>
        {accepted.length > 0 ? (
          <Button variant="contained" color="primary" onClick={onGoResults}>
            Ver seguimiento del lote
          </Button>
        ) : (
          <Button variant="contained" color="primary" onClick={onNewBatch}>
            Nuevo lote
          </Button>
        )}
      </div>
    </div>
  );
};

export default SubmitSummary;
